import React from 'react'; 
import { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Grid, Checkbox, FormControlLabel, Avatar, TextField, IconButton } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { signUpSchema } from '../validation/schemas';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
// Redux
import { useDispatch } from 'react-redux';
import { updateUserOnReduxAndServer } from '../redux/userSlice';
import { useSelector } from 'react-redux';
// Firebase Auth
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { PRIMARY_COLOR } from '../colorPalette';
// Schemas
import { UserSchema } from 'lumas-shared-schemas';


function SignUp() {

    const loading = useSelector((state) => state.user.loading);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    const isUserLoaded = useSelector((state) => state.user.isUserLoaded);

    const [userCreationError, setUserCreationError] = React.useState(null);

    const handleFormSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        const { email, password } = values;

        const normalizedEmail = email.trim().toLowerCase(); // Trim and lowercase email

        const auth = getAuth(); // Initialize Firebase Auth

        try {
            // Create a new Firebase user
            const userCredential = await createUserWithEmailAndPassword(auth, normalizedEmail, password);
            console.log("User created successfully:", userCredential.user, userCredential);

            // Create a new DDBUser to store user data (while validating against schema in lumas-shared-schemas)
            const dynamoUserObject = UserSchema.parse({
                email: normalizedEmail,
                username: values.username,
                groups: [],
                hearts: []
            });
            dispatch(updateUserOnReduxAndServer({id: normalizedEmail, updatedUser: dynamoUserObject, dispatch})); // Add user to Redux store and DynamoDB

        } catch (error) {
            console.error("Error creating user:", error.message);
            // Optional: display error message to user
            setUserCreationError(error.message);
        } finally {
            setSubmitting(false);
        }
    }

    // Navigate when the user object has been successfully populated
    useEffect(() => {
        if (isUserLoaded && user) {
            navigate('/home'); // Redirect to the desired route
        }
    }, [isUserLoaded, user, navigate]);

    return (
        <AppContainer>
        <Formik
        initialValues={{ username: '', email: '', password: '' }}
        validationSchema={signUpSchema}
        onSubmit={handleFormSubmit}
        >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight, alignItems: 'center' }}>
                <Box sx={{marginTop: '50px', width: '100%'}}>
                    <IconButton color='black' onClick={() => {navigate(-1)}}>
                        <ArrowBackIcon/>
                    </IconButton>
                </Box>
                <Avatar sx={{ m: 1, bgcolor: PRIMARY_COLOR}}>
                  <PersonIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Sign Up</Typography>
                <TextContainer>
                    <Field 
                        as={TextField}
                        id='username'
                        name='username'
                        sx={{width: '100%', marginTop: '20px'}} 
                        label="Username"
                        variant="filled" 
                        required
                        error={errors.username && touched.username}
                    />
                    <ErrorMessage name="username" component="div" style={{ color: 'red' }} />
                    <Field 
                        as={TextField}
                        id='email'
                        name='email'
                        sx={{width: '100%', marginTop: '20px'}} 
                        label="Email Address"
                        variant="filled" 
                        required
                        error={errors.email && touched.email}
                    />
                    <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                    <Field 
                        as={TextField}
                        id='password'
                        type='password'
                        name='password'
                        sx={{width: '100%', marginTop: '20px'}} 
                        label="Password"
                        variant="filled" 
                        required
                        error={errors.password && touched.password}
                    />
                    <ErrorMessage name="password" component="div" style={{ color: 'red' }} />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? "Signing up..." : "Sign up"}
                    </Button>
                    {userCreationError && <Typography variant="body2" color="error">{userCreationError}</Typography>}

                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginTop: 2,
                      paddingTop: 2,
                      borderTop: '1px solid #ddd',
                      position: 'relative',
                      width: '100%',
                    }}>
                        <Box component="span" sx={{ flex: 1, borderBottom: '1px solid #ddd', marginRight: 1,}}/>
                        <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '10px'}}>Already have an account?</Typography>
                        <Button fullWidth variant="outlined" onClick={() => {navigate('/login')}}>Log In</Button>
                    </Box>
                </TextContainer>
            </Box>
          </Form>
        )}
      </Formik>
    </AppContainer>
    )
}

export default SignUp